import { useUserStore } from '@libs/acp/store/user/useUserStore';
import { getFirstName } from '@libs/acp/utils/userFormatters';

export const useUser = () => {
  const customer = useUserStore((s) => s.authenticatedUser?.acp?.customer);
  const auth = useUserStore((s) => s.authenticatedUser?.acp?.auth);
  return {
    id: customer?.id,
    uuid: customer?.uuid,
    document: customer?.document,
    email: customer?.email,
    phone: customer?.phone,
    fullName: customer?.full_name,
    firstName: getFirstName(customer?.full_name),
    socialName: customer?.social_name,
    birthdate: customer?.birthdate,
    customerIdHash: customer?.customerIdHash,
    emailStatus: customer?.contactStatus?.email,
    accessToken: auth?.access_token,
    isAuthenticated: Boolean(auth?.isAuthenticated),
  };
};
